export const MOCK_USER_NAME = 'Juan';
export const MOCK_AVATAR_URL = '/user.png';
